import { render, staticRenderFns } from "./context-item.vue?vue&type=template&id=e4fcc63a&"
import script from "./context-item.vue?vue&type=script&lang=js&"
export * from "./context-item.vue?vue&type=script&lang=js&"
import style0 from "./context-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports